import { render, staticRenderFns } from "./XMLFields.vue?vue&type=template&id=19090b02&scoped=true&"
import script from "./XMLFields.vue?vue&type=script&lang=js&"
export * from "./XMLFields.vue?vue&type=script&lang=js&"
import style0 from "./XMLFields.vue?vue&type=style&index=0&id=19090b02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19090b02",
  null
  
)

export default component.exports